import { useTranslation } from 'react-i18next';
import {
  configurationPageClass,
  configurationPageContentClass,
} from '@modules/configuration/components/configurationLayout';
import { Information } from './Information';
import { Password } from './Password';

export function ProfileView() {
  const { t } = useTranslation('profileModule');

  return (
    <div className={configurationPageClass} data-testid="profile-view">
      <div className="shrink-0">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">{t('pageTitle')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('pageDescription')}</p>
      </div>

      <div className={`${configurationPageContentClass} space-y-6 overflow-y-auto pb-6`}>
        <Information />
        <Password />
      </div>
    </div>
  );
}
